import React, { useContext, useState } from 'react';
import 'scss/Main.scss';

export type PendingProviderContextType = {
    showPending: boolean;
    setPending: React.Dispatch<React.SetStateAction<boolean>>;
    doPendingTask: <T1 = unknown, T2 = unknown>(task: () => Promise<T1>) => Promise<T2>;
};

const PendingProviderContext = React.createContext<PendingProviderContextType>(
    {} as PendingProviderContextType
);

const PendingProvider = ({ children }: React.PropsWithChildren) => {
    const [showPending, setShowPending] = useState<boolean>(false);

    return (
        <>
            <PendingProviderContext.Provider
                value={{
                    showPending,
                    setPending: setShowPending,
                    doPendingTask: async (task: () => Promise<any>) => {
                        setShowPending(true);
                        try {
                            return await task();
                        } finally {
                            setShowPending(false);
                        }
                    },
                }}
            >
                {showPending && <div className="ui-block"></div>}
                {children}
            </PendingProviderContext.Provider>
        </>
    );
};

const usePendingState = () => useContext<PendingProviderContextType>(PendingProviderContext);

export { PendingProvider, usePendingState };
